import { EnvironmentOutlined, FileMarkdownOutlined } from '@ant-design/icons';
import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";

function OsmMap({ position }) {
    return (
        <>
            <MapContainer center={position} zoom={13} style={{ height: "inherit", width: "100%" }}>
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                />
                
                {/* <Marker position={position}>
                  <Popup>
                    A popup example. You can add more details here.
                  </Popup>
                </Marker> */}
              </MapContainer>
        </>
    );
}

export default OsmMap;